import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  headerMargin : {
    marginTop: 16
  },
  linkMargin: {
    marginTop: 16,
    marginLeft: 8,
    marginBottom: 32
  }
}));

export default styles;